import React from "react";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import CollapsibleWrapper from "../../../components/shared/collapsibleWrapper";
import Image from "../../../components/image";

import DownloadIcon from "images/icons/fi-rr-download.inline.svg";

const Itinerary = ({
  itineraryDetails,
  itineraryList,
  setItineraryOpenModal,
  programItineraryFile
}) => {
  const breakpoint = useBreakpoint();

  const ItineraryUnit = ({ unit, unitClass }) => {
    return (
      <div className={unitClass}>
        <h3 className="font-medium !text-white text-sm flex flex-col flex-1 p-2 text-center">
          {unit}
        </h3>
      </div>
    );
  };

  return (
    <>
      <div className={""}>
        {itineraryDetails?.itineraryTitle && (
          <h2 className="heading text-left py-5">
            {itineraryDetails?.itineraryTitle}
          </h2>
        )}

        <div className="divide-y width-divider" />
        {itineraryDetails?.itineraryIntroText && (
          <div
            className={
              "planet:gvi-light-gray-text text-black-lighter text-sm pt-10 pb-5 tab-content_html"
            }
            dangerouslySetInnerHTML={{
              __html: itineraryDetails?.itineraryIntroText
            }}
          />
        )}

        {programItineraryFile && (
          <div className="py-5 sm:w-2/3">
            <button
              className="flex justify-center w-full sm:w-auto py-2 px-6 border border-black-lighter planet:border-white rounded-xxxxl planet:rounded-sm text-[16px] sm:text-base sm:justify-around !text-generic-text planet:!text-white visited:text-generic-text hover:border-0 hover:bg-black-lighter hover:!text-white planet:hover:bg-white planet:hover:border-0 planet:hover:!text-generic-text group"
              onClick={() => setItineraryOpenModal(true)}
            >
              Download itinerary
              <span className="flex items-center pl-2">
                <DownloadIcon className="fill-black-lighter planet:fill-white m-auto w-4 planet:group-hover:fill-black-lighter group-hover:fill-white" />
              </span>
            </button>
          </div>
        )}

        <div className="grid grid-cols-1 gap-4 planet:gvi-light-gray-text text-sm">
          <ConditionalSwiper
            condition={breakpoint === "xs"}
            slidesPerView={1.25}
            spaceBetween={10}
            centeredSlides={false}
            className="h-full w-full"
          >
            {itineraryList?.map((itinerary, idx) => (
              <div
                key={`itinerary-${idx}`}
                className="planet:bg-gray-darker bg-secondary-bg  rounded-md flex flex-col sm:flex-row h-full sm:h-48"
              >
                <div className="relative">
                  <ItineraryUnit
                    unit={itinerary.itineraryDay}
                    unitClass={
                      "flex sm:hidden absolute planet:gvi-gray-bg bg-yellow-standard rounded-b-xs w-20 w-fit right-0 mr-2"
                    }
                  />

                  <Image
                    imageClass={
                      "rounded-t-md h-40 w-full sm:rounded-l-md sm:rounded-r-none sm:h-full sm:w-48 object-cover object-center"
                    }
                    imageAlt={""}
                    image={""}
                    sourceUrl={itinerary.itineraryImage?.sourceUrl}
                  />
                </div>

                <div className="bh-block-content px-4 sm:px-8 flex flex-1 flex-col">
                  <ItineraryUnit
                    unit={itinerary.itineraryDay}
                    unitClass={
                      "sm:flex hidden planet:gvi-gray-bg bg-yellow-standard self-end w-20 rounded-b-xs"
                    }
                  />

                  <CollapsibleWrapper
                    desc={itinerary.itineraryDescription}
                    descStyle=""
                    btnStyle="underline underline-offset-2 pt-2 text-black-lighter font-lato planet:font-normal planet:text-gray-generic text-xs flex items-center gap-2"
                    wrapperContainer=" flex-1 planet:text-gray-generic text-black-lighter text-sm my-4 tab-content_html overflow-auto"
                    visibleLength={250}
                    visibleLines={8}
                    type={"both"}
                  />
                </div>
              </div>
            ))}
          </ConditionalSwiper>
        </div>
      </div>
    </>
  );
};

export default Itinerary;
